import { md5 } from "js-md5";
import { Base64 } from "js-base64";
import moment from "moment";
import useUserStore from "@/stores/user";
import { ApiPerson } from "@/api/person";

const getUserToken = () => {
  const userStore = useUserStore();
  return userStore.token || localStorage.getItem("AI-Token") || "";
};
// 处理加密参数  post  方法
export const signData = (data: any) => {
  const appId = "JKapLf72FJyaNLs8";
  const appSecret = "m7TsMCtH@ryQKrCGhLv#CpA3utSz596G";
  const dataString = JSON.stringify(data);
  const timestamp = moment().format("x");
  const signString =
    appId +
    ":" +
    dataString +
    ":" +
    timestamp +
    ":" +
    appSecret +
    ":" +
    getUserToken();
  const sign = md5(Base64.encode(signString));
  const params = `sign=${sign}&timestamp=${timestamp}&appId=${appId}&`;
  return params;
};
// 处理加密参数  get  方法
export const objectToSortedString = (obj: any) => {
  const appId = "JKapLf72FJyaNLs8";
  const appSecret = "m7TsMCtH@ryQKrCGhLv#CpA3utSz596G";
  let result = "";
  let queryParams = "";

  if (Object.keys(obj).length !== 0) {
    const sortedKeys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
    result = sortedKeys.map((key) => `${key}${obj[key]}`).join("");
    queryParams = sortedKeys.map((key) => `${key}=${obj[key]}`).join("&");
  }
  const timestamp = moment().format("x");
  const token = localStorage.getItem("AI-Token");
  const signString =
    appId + ":" + result + ":" + timestamp + ":" + appSecret + ":" + token;
  const sign = md5(Base64.encode(signString));
  const params = `${queryParams}&sign=${sign}&timestamp=${timestamp}&appId=${appId}`;
  return params;
};
export const axiosUploadFile = async (
  file: any,
  tips: boolean = true
): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);
  const appId = "JKapLf72FJyaNLs8";
  const timestamp = moment().format("x");
  const userToken = getUserToken();
  const sign = md5(
    Base64.encode(
      `${appId}::${timestamp}:m7TsMCtH@ryQKrCGhLv#CpA3utSz596G:${userToken}`
    )
  );
  formData.append("appId", appId);
  formData.append("timestamp", timestamp);
  formData.append("sign", sign);
  try {
    const response: any = await ApiPerson.upImg(formData);
    if (response.code === 200) {
      if (tips) {
        ElMessage.success("上传成功");
      }
      return response.data.fileUrl; // 返回上传的文件 URL
    } else {
      ElMessage.error(response.msg);
      return null;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    ElMessage.error("上传出错");
    return null;
  }
};

// 处理加密参数  get  方法

export const signParam  = (obj: any) => {
  const appId = "JKapLf72FJyaNLs8";
  const appSecret = "m7TsMCtH@ryQKrCGhLv#CpA3utSz596G";
  const timestamp = moment().format("x");

  let queryParams = "";

  if (Object.keys(obj).length !== 0) {
    const sortedKeys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
    queryParams = sortedKeys.map((key) => `${key}${obj[key]}`).join(":");
  }
  let result = queryParams ? ":" + queryParams : "";
  const signString =
    appId + result + ":" + timestamp + ":" + appSecret + ":" + getUserToken();
  const sign = md5(Base64.encode(signString));
  
  obj.appId = appId;
  obj.timestamp = timestamp;
  obj.sign = sign;
  return obj;
}


export const parsingFile = (params: any, callback: Function) => {
	ApiPerson.parsingFile(params)
		.then((res: any) => {
			if (res.code == 200) {
				callback(res.data);
			} else {
				callback(null);
			}
		})
		.catch((e: any) => {
			ElMessage.error("解析失败" + (e.message ?? JSON.stringify(e)));
		});
};